import { expenseListQuerySchema, type Page } from '@chukua/common';
import { useCallback, useEffect, useState } from 'react';
import { listExpenses, type ExpenseView } from '../../../../expenses/expenses.api';

export type TripExpensesState = { status: 'loading' } | { status: 'loaded'; page: Page<ExpenseView> } | { status: 'error' };

/** One trip's spend is a handful of rows, so the tab reads the server's first page at its largest size and says so if there is more. */
const query = (tripId: string) => expenseListQuerySchema.parse({ tripId: [tripId], pageSize: 100 });

export function useTripExpenses(tripId: string) {
  const [state, setState] = useState<TripExpensesState>({ status: 'loading' });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    listExpenses(query(tripId))
      .then((page) => {
        if (!cancelled) setState({ status: 'loaded', page });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });
    return () => {
      cancelled = true;
    };
  }, [tripId, attempt]);

  const retry = useCallback(() => {
    setState({ status: 'loading' });
    setAttempt((count) => count + 1);
  }, []);

  return { state, retry };
}
